import React from "react";
import "./App.css";
import { Outlet } from "react-router-dom";
import HeaderComponent from "./Components/HeaderComponent/HeaderComponent";
import FooterComponent from "./Components/FooterComponent/FooterComponent";
import { Box, Button, createTheme, ThemeProvider } from "@mui/material";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import { AnimatePresence } from "framer-motion";

const theme = createTheme({
  typography: {
    fontFamily: "Open Sans, Arial",
  },
});

function App() {
  return (
    <>
      <span tabIndex={-1} className="reset-focus"></span>
      <ThemeProvider theme={theme}>
        <Button component="a" href="#content" variant="outlined" sx={{ position: "absolute", left: 0, top: 90, m: 0, zIndex: 1000 }}>
          דלג לתוכן
        </Button>
        <HeaderComponent />
        <ScrollToTop />
        <AnimatePresence mode="wait">
          <Outlet />
        </AnimatePresence>
        <FooterComponent />
      </ThemeProvider>
    </>
  );
}

export default App;
